export default __webpack_public_path__ + "1bee6d0.png";